import { AfterViewInit, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoginService } from 'src/app/login/login.service';
import { HttpService } from '../../core/http/http.service';
import { DonorSidebarService } from './donor-sidebar.service';
import { SidebarService } from '../sidebar/sidebar.service';

@Component({
  selector: 'app-donor-sidebar',
  templateUrl: './donor-sidebar.component.html',
  styleUrls: ['./donor-sidebar.component.css'],
  providers: [NgbModule]
})
export class DonorSidebarComponent implements OnInit, AfterViewInit {
  hide: boolean = true;
  hideSideNav: boolean = false;
  fullscreen: boolean = false;
  hoverExpand = false;
  panelOpenState = false;
  user: any;
  menuList: any;
  subMenuList: any;
  activeSubmenu: any = null;

  @Output() public valueChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private loginService: LoginService,
    private httpService: HttpService,
    private router: Router,
    private sidebarService: SidebarService
  ) { }

  ngOnInit(): void {
    this.loginService.user.subscribe(res => {
      this.sidebarService.loginId = res?.responseObject?.userdetailDTO?.loginId;
      this.sidebarService.userId = res?.responseObject?.userdetailDTO?.userId;
      this.sidebarService.RoleDTOName = res?.responseObject?.RoledetailDTO?.roleShortName;
      this.menuList = res?.responseObject.menuDetailList;
      this.sidebarService.subMenuList = this.menuList;
    });
    this.httpService.setDataAccessDto();
  }

  menuClick(i: number) {
    // this.subMenuList = this.menuList[i]?.subMenuDetailList;
    const functionId = this.menuList[i]?.functionMasterId ?? 0
    const allSubMenus = this.menuList[i]?.subMenuDetailList;
    if (functionId == 11) {
      this.subMenuList = allSubMenus.filter(submenu => [388, 390, 392, 394].includes(submenu.subFunctionMasterId));
    } else {
      this.subMenuList = allSubMenus;
    }
  }

  subMenuClick(submenu: any) {
    const routeId = submenu.subFunctionMasterId;
    console.log(routeId, submenu.subFunctionShortName);

    // Route mapping by grouped route IDs
    const routeMap: { [key: string]: number[] } = {
      '/user': [1, 2, 3, 4],
      '/role-access': [5, 6, 7, 8],
      '/vertical': [9, 10, 11, 12],
      '/sub-vertical': [13, 14, 15, 16],
      '/donor': [17, 18, 19, 20],
      '/project': [21, 22, 23, 24],
      '/mou': [25, 26, 27, 28],
      '/region-branch': [29, 30, 31, 32],
      '/block': [37, 38, 39, 40],
      '/gp': [41, 42, 43, 44],
      '/village-setup': [49, 50, 51, 52],
      '/branch-villageMap': [57, 58, 59, 60],
      '/Baseline-Survey/create': [65, 66, 67, 68],
      '/Baseline-Survey/view': [73, 74, 75, 76],
      '/children-register/create': [81, 82, 83, 84],
      '/central-register/view': [89, 90, 91, 92],
      '/muac-register/create': [97, 98, 99, 100],
      '/pem-register/create': [113, 114, 115, 116],
      '/lmr': [121, 122, 123, 124],
      '/acr': [105, 106, 107, 108],
      '/pw-register': [129, 130, 131, 132],
      '/daily-activity-register': [137, 138, 139, 140],
      '/ss-setup': [177, 178, 179, 180],
      '/user-hh-ss-remap': [185],
      '/district-setup': [186, 187, 188, 189],
      '/report/geographicalReport': [161, 162, 163, 164],
      '/report/beneficiaryInfo': [195, 196, 197, 198],
      '/report/dpr': [358, 359],
      '/ss-unmap': [194],
      '/ss-unmap-remap': [203],
      '/remap-user-hh': [205, 368],
      '/remap-user-ss': [206],
      '/close-baseline': [207],
      '/app-version': [208, 209, 210, 211],
      '/ss-training': [212, 213, 214, 215],
      '/material-distribution-register': [226, 227, 228, 229],
      '/daily-activity-record': [234],
      '/health-forum': [246, 247, 248, 249],
      '/escort-reref-register': [266, 267, 268, 269],
      '/sattu-register': [274, 275, 276, 277],
      '/sattu-register-report': [282],
      '/event-register': [286, 287, 288, 289],
      '/adolescent-girl': [294, 295, 296, 297],
      '/reset-location': [313, 367],
      '/adolscent-girl-register': [314, 315, 316, 317],
      '/adolescent-girl-leadership': [322, 323, 324, 325],
      '/ag-healthcamp': [330, 331, 332, 333],
      '/mother-child-assessment': [338, 339, 340, 341],
      '/ag-batch': [370, 372, 374, 376],
      '/other-dar-register': [378, 380, 382],
      '/report/region-wise-report': [385],
      '/report/donor-report': [386],
      '/school-info-register': [388, 390, 392, 394]
    };

    // Find the route that contains this routeId
    const matchedRoute = Object.keys(routeMap).find(route =>
      routeMap[route].includes(routeId)
    );

    if (matchedRoute) {
      this.router.navigate([matchedRoute]);
    } else {
      console.warn('No route found for routeId:', routeId);
    }
  }

  hideSideBar() {
    this.hideSideNav = !this.hideSideNav;
    this.hide = !this.hide;
    this.fullscreen = !this.fullscreen;
    this.valueChange.emit(this.fullscreen);
  }

  isActive(submenu: any): boolean {
    return this.activeSubmenu === submenu;
  }

  ngAfterViewInit(): void {
    let a: any = document.querySelectorAll(".card-header");

    for (let i = 0; i < a.length; i++) {
      a[i].style.padding = 0;
    }
  }

  clickOnImg() {
    this.activeSubmenu = null;
  }
}
